import { useIsomorphicLayoutEffect } from '@/hooks/Custom'
import { useState } from 'react'

const useAxios = (instace, method, url, requestConfig) => {
    const [Response, setResponse] = useState(null)
    const [Error, setError] = useState('')
    const [Loading, setLoading] = useState(true)

    useIsomorphicLayoutEffect(() => {
        const Controller = new AbortController()

        const MakeRequest = async () => {
            try {
                const resp = await instace[method.toLowerCase()](url, {
                    ...requestConfig,
                    signal: Controller.signal
                })
                setResponse(resp.data)
            } catch (error) {
                setError(error)
            } finally {
                setLoading(false)
            }
        }

        MakeRequest()

        return () => Controller.abort()
    }, [])

    return [Response, Error, Loading]
}

export { useAxios }
